import { ShiftDigitalService } from '@sm360/widget-commons-general';
import { PurchaseMethodsV25, Vehicle } from '@sm360/widget-commons-vehicle';

const { PurchaseMethodsActionsV25, ApiFetchStatusConstant } = PurchaseMethodsV25;
const { TradeInVehicleActions } = Vehicle;

const triggerShiftEvent = (getState, purchaseMethod) => {
    const state = getState();
    const { quote, purchaseMethodsV25 } = state;
    ShiftDigitalService.updateDrCalculatorStart(
        quote?.id,
        quote?.vehicle,
        purchaseMethod || purchaseMethodsV25.getSelectedPurchaseMethodValue()
    );
};

export function loadPurchaseMethods() {
    return (dispatch, getState) => {
        const state = getState();
        const { purchaseMethodsV25 } = state;
        if (purchaseMethodsV25.paymentOptionsFetchStatus === ApiFetchStatusConstant.IDLE) {
            dispatch(PurchaseMethodsActionsV25.setPaymentOptionsFetchStatus(ApiFetchStatusConstant.INITIATED));
            dispatch(PurchaseMethodsActionsV25.loadPurchaseMethodsV25());
        }
    };
}

export function selectPurchaseMethod(
    purchaseMethod,
    term,
    paymentFrequency,
    kmPerYearPlan,
    cashDown,
    financePlan,
    config
) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState, purchaseMethod);
        dispatch(
            PurchaseMethodsActionsV25.selectPurchaseMethod(
                purchaseMethod,
                term,
                paymentFrequency,
                kmPerYearPlan,
                cashDown,
                financePlan,
                config
            )
        );
    };
}

export function selectTerm(term, config) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActionsV25.selectTerm(term, config));
    };
}

export function selectPaymentFrequency(paymentFrequency, config) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActionsV25.selectPaymentFrequency(paymentFrequency, config));
    };
}

export function setCashDown(cashDown, config) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActionsV25.setCashDown(cashDown, config));
    };
}

export function updateTargetPayment(targetPayment, config) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActionsV25.updateTargetPayment(targetPayment, config));
    };
}

export function setTradeIn(tradeIn, config) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActionsV25.setTradeIn(tradeIn, config));
    };
}

export function saveTradeInVehicle(tradeInVehicle) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(TradeInVehicleActions.saveTradeInVehicle(tradeInVehicle));
    };
}

export function setLien(lien, config) {
    return (dispatch) => {
        dispatch(PurchaseMethodsActionsV25.setLien(lien, config));
    };
}

export function setTradeInAndLien(tradeIn, lien, config) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActionsV25.setTradeInAndLien(tradeIn, lien, config));
    };
}

// export function setExteriorColourAmounts(exteriorColourAmounts) {
//     return (dispatch) => {
//         dispatch(PurchaseMethodsActionsV25.setExteriorColourAmounts(exteriorColourAmounts));
//     };
// }

// export function setInteriorColourAmounts(interiorColourAmounts) {
//     return (dispatch) => {
//         dispatch(PurchaseMethodsActionsV25.setInteriorColourAmounts(interiorColourAmounts));
//     };
// }

// export function setOptionsAmounts(optionsAmounts) {
//     return (dispatch) => {
//         dispatch(PurchaseMethodsActionsV25.setOptionsAmounts(optionsAmounts));
//     };
// }

// export function setTaxesIncluded(taxesIncluded) {
//     return (dispatch) => {
//         dispatch(PurchaseMethodsActionsV25.setTaxesIncluded(taxesIncluded));
//     };
// }

export function setKMPlan(kmPlan, config) {
    return (dispatch, getState) => {
        triggerShiftEvent(getState);
        dispatch(PurchaseMethodsActionsV25.setKMPlan(kmPlan, config));
    };
}

export function setShiftEvent(isNotFromUser) {
    return (dispatch, getState) => {
        if (!isNotFromUser) triggerShiftEvent(getState);
    };
}
